//show redux store
const middlewareLogger = (store) => (next) => (action) => {
  // console.log("OG State:", store.getState());
  // console.log("Current action:", action);
  next(action);
  // console.log("new updated state", store.getState());
};

export default middlewareLogger;
